import axios from './index';

/**
 * 获取路由信息
 * @param {object} params
 * @param {string} params.id 竞赛id
 */
export function getLinkInfo(params = {}) {
  return axios.get('/user/public/getCompPage', { params });
}

/**
 * 获取模块信息
 * @param {object} params
 * @param {string} params.id 页面id
 */
export function getCompModuleList(params = {}) {
  return axios.get('/user/public/getCompModuleList', { params });
}
/**
 * 内部竞赛判断是否已报名
 * @param {
   string
 }
 competitionId 页面id
 */
export function getIsRegister(competitionId) {
  return axios.get(`/inner/reg/determine/${competitionId}`);
}
/**
 * 内部竞赛报名
 * @param {
   obj
 }
 */
export function insideRegister(param) {
  return axios.post('/inner/reg', param);
}
/**
 * 获取全局配置
 * @param {
   string
 }
 compId 页面id
 */
export function getConfig(compId) {
  return axios.get(`glb/settings/formal/${compId}`);
}

export function getSerialList(params) {
  return axios.get(`/portal/serial/list`,{params});
}
